var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.119,
    height: 17,
    viewBox: "0 0 18.119 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93,262.834c.129-.282.243-.574.391-.844q3.824-7.009,7.656-14.013a1.088,1.088,0,0,1,1.373-.638,1.262,1.262,0,0,1,.65.628q1.608,2.95,3.221,5.9,2.305,4.217,4.611,8.433a1.42,1.42,0,0,1,.191,1,1.143,1.143,0,0,1-.956.954,2.079,2.079,0,0,1-.265.016q-7.813,0-15.625,0a1.093,1.093,0,0,1-1-.471,3.527,3.527,0,0,1-.249-.573Zm9.82-7.12h.017c.024-.858.052-1.716.07-2.575a.733.733,0,0,0-.589-.8,1.289,1.289,0,0,0-.455-.01.733.733,0,0,0-.649.839q.076,2.6.167,5.207a.48.48,0,0,0,.38.512,1.291,1.291,0,0,0,.472.025c.347-.052.5-.256.511-.643Q102.784,256.991,102.82,255.713Zm-.759,6.1a1,1,0,0,0,.018-1.987.951.951,0,0,0-.9.973A.963.963,0,0,0,102.061,261.817Z",
    transform: "translate(-93 -247.268)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.2abffd06cc4f8682522e3bafd72a0cc6.svg";
export { ForwardRef as ReactComponent };